import React from 'react'
import { connect } from 'react-redux'
import { range, findIndex, omit, keys } from 'lodash'
import Dimensions from 'react-dimensions'
import { Origin } from 'redux-tooltip';
import './index.css'

var d3 = require('d3')
const Ocircle = Origin.wrapBy('circle')


class TrendLine extends React.PureComponent {
  render() {

    const { scale, margin, numYears=5, containerWidth, countryCode, dataByCountry, maxYear=2016 } = this.props
    const years = range(maxYear - numYears + 1, maxYear + 1).map(i => i.toString())
    const plotData = years.map(year => {
      return dataByCountry[year] ? {
        year,
        ...dataByCountry[year]
      } : null
    })
    const yearWidth = (containerWidth - (margin * 2)) / (numYears - 1);

    const trendLines = plotData.reduce((accumulator, currentValue, currentIndex)=>{
      if(currentIndex === plotData.length){
        return accumulator
      }
      if(currentValue !== null){
        const nextIndex = findIndex(plotData, (item, i) => (i > currentIndex && item))
        if(nextIndex !== -1){
          accumulator.push({
            x1: margin+currentIndex*yearWidth, y1:scale(currentValue.v),
            x2: margin+nextIndex*yearWidth, y2:scale(plotData[nextIndex].v),
            virtual : nextIndex > currentIndex + 1
          })
        }
      }
      return accumulator
    }, [])

    return (
      <g>
        { trendLines.map((trendLine, i) => {
          const lineAttrs = omit(trendLine, ['virtual'])
          return (
            <line key={i} {...lineAttrs}
              className={`trend-line ${trendLine.virtual ? 'virtual' : ''}`}
              // content={`${countryCode}`}
            />
          )
        })}
        {plotData.map((datum, i) => (
          datum && (
            <Ocircle
              key={i} r={1} cx={margin+i*yearWidth} cy={scale(datum.v)}
              className="circle-datum" content={`${countryCode} ${datum.v} (${datum.year})`}/>
          )
        ))}
      </g>
    )
  }
}

class MultiTrendChart extends React.PureComponent {
  render() {

    const { indicatorData, margin=0, height=50, numYears=5, containerWidth, containerHeight,  dataByIndicator } = this.props

    if(!indicatorData.domain){
      return null
    }
    //SCALE direction depends on indicator "rankDirection"
    let rangeForIndicator;
    if(indicatorData.rankDirection === "1"){
      rangeForIndicator = [margin, height-(margin*2)]
    } else {
      rangeForIndicator = [height-(margin*2), margin]
    }
    const scale = d3.scaleLinear().domain(indicatorData.domain).range(rangeForIndicator)
    const countries = keys(dataByIndicator)

    return (
      <svg height={height} width={containerWidth} className="MultiTrendChart__svg">
        { countries.map(country => (
          <TrendLine key={country}
            containerWidth={containerWidth}
            indicatorData={indicatorData}
            height={containerHeight}
            maxYear={2016}
            numYears={numYears}
            countryCode={country}
            scale={scale}
            margin={0}
            dataByCountry={dataByIndicator[country]}/>
        ))}
      </svg>
    )
  }
}


const mapStateToProps = (state, props) => ({
  //dataByCountry : getTrendDataByCountryAndIndicator(state, props),
  //indicators: state.indicators,
  countries: state.countries,
})

export default connect(mapStateToProps)(Dimensions()(MultiTrendChart))



// WEBPACK FOOTER //
// ./src/components/MultiTrendChart/index.js